// ABOUTME: Admin route wrapper that requires admin role.
// ABOUTME: Redirects non-admin users to home page.

import { type ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '@/context/AuthContext';
import { LoadingSpinner } from '@/components/ui/LoadingSpinner';

interface AdminRouteProps {
  children: ReactNode;
}

export function AdminRoute({ children }: AdminRouteProps) {
  const { isAuthenticated, isLoading, user } = useAuth();

  // Debug logging
  console.log('[AdminRoute] Auth state:', {
    isAuthenticated,
    isLoading,
    userRole: user?.role,
    userName: user?.name,
    userEmail: user?.email,
  });

  if (isLoading) {
    return (
      <div className="flex items-center justify-center h-screen bg-surface-50">
        <LoadingSpinner size="lg" />
      </div>
    );
  }

  if (!isAuthenticated) {
    console.log('[AdminRoute] Not authenticated, redirecting to /');
    return <Navigate to="/" replace />;
  }

  if (user?.role !== 'admin') {
    console.log('[AdminRoute] User role is not admin:', user?.role, 'redirecting to /');
    return <Navigate to="/" replace />;
  }

  console.log('[AdminRoute] Access granted');
  return (
    <div className="h-full overflow-y-auto p-8">
      <div className="max-w-6xl mx-auto">
        {children}
      </div>
    </div>
  );
}
